import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import { convertPlantingPlanParams } from 'util/parse';
import { inferUnit } from 'util/unitConversion';

import HtmlText from 'html-text/HtmlText';
import Explainer from './Explainer';
import PlantingPlanTextInput from './PlantingPlanTextInput';
import YieldMapsHistoricalData from './YieldMapsHistoricalData';


const baseString = 'vra-planting-plan__target-yield';
const TargetYield = ({
  canViewYieldData,
  isReviewScriptStep,
  onChangeTargetYield,
  targetYield,
  validationResult,
  yieldMapsHistoricalData,
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    'vra-planting-plan-form__fieldset': true
  });

  const densityToolClass = 'density-tool';

  const { display } = convertPlantingPlanParams({
    validationResult,
    value: targetYield
  });

  return (
    <div className={densityToolClass}>
      <section className={classString}>
        <div className={`vra-planting-plan-form__inputs-wrapper ${densityToolClass}`}>
          <PlantingPlanTextInput
            className={`${baseString}__input`}
            dataTestId='target-yield-input'
            label={getMessage('target-dry-yield')}
            onChange={onChangeTargetYield}
            placeholder={getMessage('placeholder-text__target-yield-avg', yieldMapsHistoricalData)}
            validationResult={validationResult}
            value={display}>
            <span className='vra-planting-plan-form__inputs-units'>
              {inferUnit('area-density.yield').symbol.quantitySpecific}
            </span>
          </PlantingPlanTextInput>
        </div>
        <Explainer isVisible={!isReviewScriptStep}>
          <HtmlText messageKey='text__advanced-script__target-dry-yield' />
        </Explainer>
      </section>
      <section className='vra-planting-plan-form__inputs-wrapper'>
        <YieldMapsHistoricalData
          canViewYieldData={canViewYieldData}
          isReviewScriptStep={isReviewScriptStep}
          yieldMapsHistoricalData={yieldMapsHistoricalData}
        />
      </section>
    </div>

  );
};
TargetYield.propTypes = {
  canViewYieldData: propTypes.bool.isRequired,
  helpMessage: propTypes.any,
  isReviewScriptStep: propTypes.bool.isRequired,
  onChangeTargetYield: propTypes.func.isRequired,
  targetYield: propTypes.string,
  validationResult: propTypes.object,
  yieldMapsHistoricalData: propTypes.object.isRequired,
};
export default TargetYield;
